import { useState } from "react"
import { useField } from "formik"
import { SelectedPriceListItem } from "../createOrderTypes"

export const useSelectPriceLists = (additionalFunction: () => void) => {
    const [showSelectPriceListsDialog, setShowSelectPriceListsDialog] = useState(false)
    const [, , helpers] = useField<SelectedPriceListItem>("priceList")

    const handleSelectPriceList = (selected: SelectedPriceListItem) => {
        helpers.setValue(selected)

        setShowSelectPriceListsDialog(false)
        additionalFunction()
    }

    return { showSelectPriceListsDialog, setShowSelectPriceListsDialog, handleSelectPriceList }
}
